import { Component, EventEmitter, Input, Output } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PaginationComponent } from "../../../pagination/pagination.component";
import { PaginationState } from "../../../../models/pagination";
import { FilterItem, TableRow, TotalRowsPayload } from "../../../../models/common-table";
import { DEFAULT_PAGE_SIZE } from "../../../../constant/tables";

@Component({
  selector: "app-common-table-footer",
  standalone: true,
  imports: [CommonModule, PaginationComponent],
  templateUrl: "./common-table-footer.component.html",
})
export class CommonTableFooterComponent {
  @Input() loading: boolean = false;
  @Input() showPagination: boolean = true;
  @Input() pageNumber: number = 0;
  @Input() disabled: boolean = false;
  @Input() dynamicPagination: boolean = false;
  @Input() exactRows: number | undefined;
  @Input() pageSize: number = DEFAULT_PAGE_SIZE;
  @Input() tableRows: TableRow[] = [];
  @Input() totalRowsPayload?: TotalRowsPayload;

  @Output() pageChanged: EventEmitter<PaginationState<TableRow>> = new EventEmitter<PaginationState<TableRow>>();

  private lastPaginationState: string = "";

  public handlePageChanged(newPageState: PaginationState<TableRow>): void {
    const currentState: string = JSON.stringify({
      pageNumber: newPageState.pageNumber,
      pageSize: newPageState.pageSize,
      currentPageLength: newPageState.currentPage?.length ?? 0,
    });

    if (this.lastPaginationState === currentState) {
      return;
    }

    this.lastPaginationState = currentState;
    this.pageChanged.emit(newPageState);
  }
}
